<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body">
                        <form [formGroup]="documentDownloadForm">
                            <table class="table" id="table">
                                <thead id="table-thead">
                                    <tr class="bg-light">
                                        <th scope="col" width="300">Date</th>
                                        <th scope="col" width="300">Document Type</th>
                                        <th scope="col" width="300" *ngIf="context.persona === 'EMPLOYEE'">Document</th>
                                        <th scope="col" width="300" *ngIf="context.persona === 'HR'">File</th>
                                        <th scope="col" width="300" *ngIf="context.persona === 'HR'"
                                            class="text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody formArrayName="documentDownloads">
                                    <tr *ngFor="let document of documentDownloads.controls; let i=index"
                                        [formGroupName]="i">
                                        <td>
                                            <div class="input-group"> <span
                                                    class="input-group-text bg-transparent  border-end-0"><i
                                                        class='bx bx-calendar'></i></span>
                                                <input type="date" class="form-control ps-1" id="genearatedDate"
                                                    formControlName="genearatedDate"
                                                    [readOnly]="context.persona === 'EMPLOYEE'" />
                                            </div>
                                        </td>
                                        <td class="col-lg-4 px-0">
                                            <div class="input-group">
                                                <span class="input-group-text bg-transparent border-end-0">
                                                    <i class='bx bx-repost'></i>
                                                </span>
                                                <ng-select class="form-control rcx-ng-select" formControlName="type"
                                                    placeholder="Select a Document type"
                                                    [ngClass]="{'is-invalid': submitted && documentDownloadForm.get('type')?.errors}"
                                                    [readonly]="context?.persona === 'EMPLOYEE'">
                                                    <ng-option *ngFor="let type of types" [value]="type">
                                                        {{ type }}
                                                    </ng-option>
                                                </ng-select>
                                                <div class="invalid-feedback"
                                                    *ngIf="submitted && documentDownloadForm.get('type')?.errors">
                                                    <span
                                                        *ngIf="documentDownloadForm.get('type')?.errors?.required">Please
                                                        select a type</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td *ngIf="context.persona === 'EMPLOYEE'">
                                            <button class="btn btn-secondary btn-sm ms-2 me-2" title="Download Document"
                                                (click)="downloadFile(document?.value.filePath, i)">
                                                <i class="bx bx-download"></i>
                                            </button>
                                        </td>
                                        <td class="col-lg-4" *ngIf="context.persona === 'HR'">
                                            <div class="input-group">
                                                <input type="file" class="form-control" id="upload"
                                                    accept=".pdf, .doc, .docx" (change)="onFileSelected($event)">
                                            </div>
                                        </td>
                                        <td class="text-center" *ngIf="context.persona === 'HR'">
                                            <button type="button" *ngIf="!document.value.filePath; else plusButton"
                                                (click)="saveDocuments(document, i)"
                                                class="btn btn-secondary btn-sm me-2">
                                                <i class='bx bx-save' title="Save Document"></i>
                                            </button>
                                            <ng-template #plusButton>
                                                <button type="button" (click)="addDocumentDownload()"
                                                    class="btn btn-secondary btn-sm me-2">
                                                    <i class='bx bx-plus' title="Add New Row"></i>
                                                </button>
                                            </ng-template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>